navApp.controller('primaryNavController', [
  '$scope', 'NavDataService', function($scope, NavDataService) {
    $scope.loading = true;
    return NavDataService.getPrimaryNav().then(function(results) {
      $scope.branches = results;
      return $scope.loading = false;
    });
  }
]);
